exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.styling_wrapper{padding:calc(4*var(--gutter)) var(--gutter)\n}\n.color_box{margin-bottom:12px;border-radius:100px;width:100%;height:5rem;background-color:var(--bg-color)\n}", "", {"version":3,"sources":["/opt/buildhome/repo/src/views/portfolio/Content/Style.vue"],"names":[],"mappings":";AACA,iBAAiB,2CAA2C;CAC3D;AACD,WAAW,mBAAmB,oBAAoB,WAAW,YAAY,gCAAgC;CACxG","file":"Style.vue","sourcesContent":["\n.styling_wrapper{padding:calc(4*var(--gutter)) var(--gutter)\n}\n.color_box{margin-bottom:12px;border-radius:100px;width:100%;height:5rem;background-color:var(--bg-color)\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c92cb48","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/portfolio/Content/Style.vue
// module id = BSdP
// module chunks = 0